import React from 'react'
import ReactLogo from './pingone-privilege.svg'

const PingPrivilegeLogo = ({ className = '' }) => {
  return <img className={className} src={ReactLogo} />
}

export { PingPrivilegeLogo }
